<template>
  <div id="toDoDetail">
    <div :class="detailShow || closeShow ? 'hiddencard' : 'moduleBox'">
      <h3>Flow Information</h3>
      <div class="moduleContent">
        <p>E-flow Name: {{ approveInfo.flowName }}</p>
        <p>E-flow Type: {{ approveInfo.flowTypeDesc }}</p>
        <p>Approval Status: {{ approveInfo.approvalStatusDesc }}</p>
        <p>Current Processor: {{ approveInfo.currentProcessor }}</p>
        <p>Involved Project: <a @click="openDetail">{{ approveInfo.majorProjectName }}</a></p>
        <p>Recommended Project Manager: {{ approveInfo.projectManager }}</p>
        <p>Major Project Level: {{ approveInfo.majorProjectLevelDesc }}</p>
        <p>Sales Region: {{ approveInfo.salesRegion }}</p>
        <div v-if="approveInfo.flowType === 2">
          <p>Updated End Date: {{ approvalContent.newEndTime ? moment(approvalContent.newEndTime).format('YYYY-MM-DD') : '' }}</p>
          <p>Project Extension Reason: {{ approvalContent.reason }}</p>
        </div>
        <div v-if="approveInfo.flowType === 3">
          <p>Project Freeze Date: {{ approvalContent.stopWorkTime ? moment(approvalContent.stopWorkTime).format('YYYY-MM-DD') : '' }}</p>
          <p>Project Freeze Reason: {{ approvalContent.reason }}</p>
          <p>Estimated Resumption Date: {{ approvalContent.expectedResumptionTime ? moment(approvalContent.expectedResumptionTime).format('YYYY-MM-DD') : '' }}</p>
        </div>
        <div v-if="approveInfo.flowType === 5">
          <p>Change Role: {{ approvalContent.role }}</p>
          <p>Change Person: {{ approvalContent.memberNameAfterChange + '(' + approvalContent.memberNoAfterChange + ')' }}</p>
          <p>Reason of Change: {{ approvalContent.reason }}</p>
          <p>Major project key person work handover approval email: 
            <a :href="approvalContent.href" target="_blank">{{ approvalContent.handoverSituationFileName }}</a>
          </p>
        </div>
        <div v-if="approveInfo.flowType === 7 || approveInfo.flowType === 8">
          <p>Project Closure: <a @click="openClose">Detail</a></p>
        </div>
        <div v-if="approveInfo.flowType === 9">
          <p>File Name: <a @click="openFile">{{ approvalContent.fileName }}</a></p>
          <p>Operation Type: {{ 
            approvalContent.operationType === 'insert' ? 'Add' : 
            approvalContent.operationType === 'delete' ? 'Delete' : 
            approvalContent.operationType === 'cover' ? 'Cover' : ''
          }}</p>
        </div>
      </div>
    </div>
    <div :class="detailShow || closeShow ? 'hiddencard' : 'moduleBox'" v-if="approveInfo.flowType === 6">
      <h3>Project Milestone</h3>
      <div class="moduleContent">
        <p v-if="missionChangeReason">Reason: {{ missionChangeReason }}</p>
        <el-table
          :data="milestoneData"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          border
          size="small"
          tooltip-effect="dark"
          row-key="id"
          default-expand-all
          :header-cell-style="{background:'#F5F5F9'}"
        >
          <el-table-column label="Key Milestone" prop="criticalMilestone" min-width="45">
            <template v-slot="scope">
              {{ scope.row.criticalMilestone === 1 ? 'Yes' : scope.row.criticalMilestone === 0 ? 'No' : '' }}
            </template>
          </el-table-column>
          <el-table-column label="Key Task" prop="missionCritical" min-width="45"></el-table-column>
          <el-table-column label="Key Task Description" prop="missionCriticalDesc" min-width="45"></el-table-column>
          <el-table-column label="Start Date" prop="startTime" min-width="45">
            <template v-slot="scope">
              {{ scope.row.startTime ? moment(scope.row.startTime).format('YYYY-MM-DD') : ''}}
            </template>
          </el-table-column>
          <el-table-column label="End Date" prop="endTime" min-width="45">
            <template v-slot="scope">
              {{ scope.row.endTime ? moment(scope.row.endTime).format('YYYY-MM-DD') : ''}}
            </template>
          </el-table-column>
          <el-table-column label="Type" prop="type" min-width="45"></el-table-column>
        </el-table>
      </div>
    </div>
    <div :class="detailShow || closeShow ? 'hiddencard' : 'moduleBox'">
      <h3>Approval</h3>
      <div class="moduleContent">
        <el-form :model="approveForm" ref="approveForm" label-width="160px">
          <el-form-item label="Comments:" prop="comments" :rules="[{ required: true, message: 'Please input' }]">
            <el-input type="textarea" :rows="4" clearable v-model="approveForm.comments" placeholder="Please input" />
          </el-form-item>
        </el-form>
        <el-button type="primary" size="small" :loading="approveLoading" @click="approve(1, 'approveLoading')" style="margin-left: 160px">Approve</el-button>
        <el-button type="danger" size="small" :loading="rejectLoading" @click="approve(0, 'rejectLoading')">Reject</el-button>
      </div>
    </div>
    <div :class="detailShow || closeShow ? 'hiddencard' : 'moduleBox'" v-if="approvalHistory && approvalHistory.length > 0">
      <h3>Approval History</h3>
      <div class="moduleContent">
        <p v-for="(word, i) in approvalHistory" :key="i">
          {{ word }}
        </p>
      </div>
    </div>
    <detail v-if="detailShow" :id="detailId" page="toDo" @closeDetail="closeDetail" />
    <project-close
      v-if="closeShow"
      ref="closeModal"
      :id="approveInfo.majorProjectId"
      :projectManagerAllList="projectManagerAllList"
      page="toDo"
      @closeDetail="closeCloseDetail"
    />
  </div>
</template>
<script>
	import detail from '../../major/projectApplication/index.vue'
	import projectClose from '../../major/projectClose/index.vue'
  import moment from 'moment';
  export default {
    name: 'toDoDetail',
		components: {
			detail,
      projectClose
		},
    props: {
      approveInfo: {
        type: Object,
        default: Object,
      },
      approvalHistory: {
        type: Array,
        default: [],
      },
    },
    created () {
      if(this.approveInfo.flowType === 2 || this.approveInfo.flowType === 3 || this.approveInfo.flowType === 5 || this.approveInfo.flowType === 6 || this.approveInfo.flowType === 9) {
        let params = {
          islhToken: sessionStorage.getItem('islhtoken'),
          eosToken: sessionStorage.getItem('eostoken'),
          flowType: this.approveInfo.flowType,
          flowId: this.approveInfo.id,
        }
        let url =`${this.$store.state.islhurl}majorProjectFlow/getApprovalContent`
        this._post(url,params).then(
          res => {
            if(res.code === 200) {
              this.approvalContent = res.data;
              if(this.approveInfo.flowType === 5) {
                this.approvalContent.href = `${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(res.data.handoverSituationFileAlias)}&fileName=${encodeURIComponent(res.data.handoverSituationFileName)}`
              }
              if(this.approveInfo.flowType === 6) {
                const list = [];
                res.data.milestoneShowDataUpdate && res.data.milestoneShowDataUpdate.forEach((item, index) => {
                  list.push({
                    id: index + 1,
                    criticalMilestone: item.newCriticalMilestone,
                    endTime: item.newEndTime,
                    missionCritical: item.newMissionCritical,
                    missionCriticalDesc: item.newMissionCriticalDesc,
                    startTime: item.newStartTime,
                    type: 'Update',
                    children: [{
                      id: 'children' + index,
                      criticalMilestone: item.oldCriticalMilestone,
                      endTime: item.oldEndTime,
                      missionCritical: item.oldMissionCritical,
                      missionCriticalDesc: item.oldMissionCriticalDesc,
                      startTime: item.oldStartTime,
                    }]
                  })
                  this.missionChangeReason = item.reason;
                });
                res.data.milestoneShowDataDelete && res.data.milestoneShowDataDelete.forEach((item, index) => {
                  list.push({
                    id: index + 1,
                    criticalMilestone: item.criticalMilestone,
                    endTime: item.endTime,
                    missionCritical: item.missionCritical,
                    missionCriticalDesc: item.missionCriticalDesc,
                    startTime: item.startTime,
                    type: 'Delete'
                  })
                  this.missionChangeReason = item.reason;
                });
                res.data.milestoneShowDataInsert && res.data.milestoneShowDataInsert.forEach((item, index) => {
                  list.push({
                    id: index + 1,
                    criticalMilestone: item.criticalMilestone,
                    endTime: item.endTime,
                    missionCritical: item.missionCritical,
                    missionCriticalDesc: item.missionCriticalDesc,
                    startTime: item.startTime,
                    type: 'Add'
                  })
                  this.missionChangeReason = item.reason;
                });
                this.milestoneData = list;
              }
            } else {
              this.$message.error(res.message || 'Failed!' );
            }
          }
        )
      }
      if(this.approveInfo.flowType === 7 || this.approveInfo.flowType === 8) {
        this.getManagementList();
      }
    },
    data () {
      return {
        moment,
        approveForm: {
          comments: 'ok'
        },
        approveLoading: false,
        rejectLoading: false,
				detailShow: false,
				detailId: '',
        milestoneData: [],
        approvalContent: {},
        closeShow: false,
        projectManagerAllList: [],
        missionChangeReason: '',
      }
    },
    methods: {
			approve(approvalResult, loading)  {
        this.$refs.approveForm.validate((valid) => {
          if (valid) {
            let params = {
              islhToken : sessionStorage.getItem('islhtoken'),
              eosToken : sessionStorage.getItem('eostoken'),
              approvalResult,
              procInsId: this.approveInfo.procInsId,
              flowName: this.approveInfo.flowName,
              approvalOpinion: this.approveForm.comments,
              // approver
            }
            this[loading] = true;
            let url =`${this.$store.state.islhurl}majorProjectFlow/approval`
            this._post(url,params).then(
              res => {
                if(res.code === 200) {
                  this.$emit('close', 'refresh')
                  this.approveForm = {};
                  this.$Message.success('Successful!');
                } else {
                  this.$message.error(res.message || 'Failed!' );
                }
                this[loading] = false;
              }
            )
          }
        });
			},
      // openDetail() {
			// 	let params = {
			// 		id: this.approveInfo.id,
			// 		page: 'toDo'
			// 	}
			// 	this.$router.push({ name:'projectApplication', params });
      //   this.$emit('close')
			// },
			openDetail(record) {
				console.log('record', record)
				this.detailShow = true;
				this.detailId = this.approveInfo.majorProjectId;
				// let params = {
				// 	id: record.majorProjectId,
				// 	page: 'myFlow'
				// }
				// this.$router.push({ name:'projectApplication', params });
			},
			closeDetail() {
				this.detailShow = false;
				this.detailId = '';
			},
      openClose() {
				this.closeShow = true;
        const closetimer = setTimeout(() => {
				  this.$refs.closeModal.setData({
            ...this.approveInfo,
            canEdit: 'no'
          });
          clearTimeout(closetimer);
        }, 200);
      },
      closeCloseDetail() {
				this.closeShow = false;
      },
      getManagementList() {
        let url2 =`${this.$store.state.islhurl}majorProjectManager/fuzzyQueryByName?empName=`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url2, params).then(
					res => {  
						if(res) {
							this.projectManagerAllList = res
						}
					}
				)
      },
      openFile() {
        const { approvalContent } = this;
        if(approvalContent.fileAliasName && approvalContent.fileName) {
          window.open(`${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(approvalContent.fileAliasName)}&fileName=${encodeURIComponent(approvalContent.fileName)}`);
        }
      }
    },
  }
</script>
<style lang="less" scoped>
#toDoDetail {
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
  padding: 0 24px;
  .moduleBox {
    border: 1px solid #e8e8e8;
    margin-bottom: 20px;
    color: #606266;
    h3 {
      border-bottom: 1px solid #e8e8e8;
      padding: 8px 20px;
      margin: 0;
      font-size: 16px;
      background-color: #f7f7f7;
      cursor: pointer;
    }
    .moduleContent {
      padding: 10px 20px;
      p {
        line-height: 24px;
        padding: 4px 0;
        font-size: 14px;
      }
      .el-form {
        padding: 10px 0;
        /deep/.el-form-item__label {
          text-align-last: left;
        }
        /deep/.el-form-item {
          margin-bottom: 12px;
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/view/myworkbench/toDo/detail.vue